if (!customElements.get('video-reels')) {
  customElements.define(
    'video-reels',
    class VideoReels extends HTMLElement {
      constructor() {
        super();
        this.activeClass = 'active';
        this.swiper = this.querySelector('.wt-slider__container');
      }

      connectedCallback() {
        this.init();
      }

      updateAllVideosSound(swiper) {
        const soundOn = swiper.el.dataset.sound === 'on';
        swiper.slides.forEach((slide) => {
          const video = slide.querySelector('video');
          if (video) video.muted = !soundOn;
        });
      }

      observeSection() {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = this.querySelector('.swiper-slide-active video');
              if (!video) return;
              entry.isIntersecting ? video.play() : video.pause();
            });
          },
          { root: null, rootMargin: '0px', threshold: 0.1 }
        );
        observer.observe(this);
      }

      handleSoundToggle(swiper) {
        swiper.slides.forEach((slide) => {
          const button = slide.querySelector('.wt-video__sound-toggle');
          const video = slide.querySelector('video');
          if (!button) return;
          button.addEventListener('click', () => {
            if (!video) return;
            if (video.muted) {
              video.muted = false;
              swiper.el.dataset.sound = 'on';
            } else {
              video.muted = true;
              swiper.el.dataset.sound = 'off';
            }
            this.updateAllVideosSound(swiper);
          });
        });
      }

      pauseAllVideos() {
        this.querySelectorAll('video').forEach((v) => v.pause());
      }

      playVideoInActiveSlide(swiper) {
        const sound = swiper.el.dataset.sound;
        const activeSlideVideo = this.findActiveSlide(swiper)?.querySelector('video');
        if (activeSlideVideo) {
          activeSlideVideo.play();
          activeSlideVideo.muted = sound !== 'on';
        }
      }

      findActiveSlide(swiper) {
        return swiper.slides[swiper.activeIndex];
      }

      toggleActiveClass(swiper) {
        const activeSlide = this.findActiveSlide(swiper);
        swiper.slides.forEach((slide) => {
          slide.classList.remove(this.activeClass);
          if (activeSlide === slide) slide.classList.add(this.activeClass);
        });
      }

      handleSlideChange(swiper) {
        this.pauseAllVideos();
        this.toggleActiveClass(swiper);
        this.playVideoInActiveSlide(swiper);
      }

      addVideoEventHandlers(swiper) {
        swiper.on('slideChange', (swp) => this.handleSlideChange(swp));
      }

      setupQuickBuyButtons(swiper) {
        const sharedModal = this.querySelector('quick-buy-modal');
        if (!sharedModal) return;
        swiper.slides.forEach((slide) => {
          const btn = slide.querySelector('.shoppable-product-card__add-button[data-quick-buy-handle]');
          if (!btn) return;
          btn.addEventListener('click', () => {
            sharedModal.setAttribute('handle', btn.dataset.quickBuyHandle);
            sharedModal.show();
          });
        });
      }

      checkSwiperInitialization() {
        const swiperContainer = this.swiper;
        if (!swiperContainer) return;
        const mySwiperInstance = swiperContainer.swiper;

        if (swiperContainer.classList.contains('swiper-initialized')) {
          this.setupQuickBuyButtons(mySwiperInstance);
          this.addVideoEventHandlers(mySwiperInstance);
          // Only mark the active slide here; playback starts in observeSection once the section is in view
          this.toggleActiveClass(mySwiperInstance);
          this.handleSoundToggle(mySwiperInstance);
          this.observeSection();
          clearInterval(this.checkInterval);
        }
      }

      init() {
        this.checkInterval = setInterval(
          this.checkSwiperInitialization.bind(this),
          500
        );
      }
    }
  );
}
